const features = [
  {
    icon: 'ri-spy-line',
    title: '独家爆料',
    desc: '每日深度挖掘，呈现最真实的内幕，让您看到不一样的世界。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时不间断，快人一步掌握资讯，永远走在信息前沿。',
  },
  {
    icon: 'ri-compasses-2-line',
    title: '多维视角',
    desc: '热点事件多角度解读，不盲从不跟风，独立思考更清醒。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问',
    desc: '多线路保障，确保用户稳定访问，信息安全有保障。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          平台优势
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          为什么选择今日看料
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-5xl mx-auto">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 text-center group"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${f.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {f.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}